import { Component, OnInit, Input, ViewChild, OnChanges, SimpleChanges } from '@angular/core';
import { FormControl, Validators } from '@angular/forms';
import { NgbTooltip } from '@ng-bootstrap/ng-bootstrap';
import { environment } from '../../../environments/environment';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-input-field',
  templateUrl: './input-field.component.html',
  styleUrls: ['./input-field.component.css']
})
export class InputFieldComponent implements OnInit, OnChanges {
  @Input() field: any;
  @ViewChild('invalidTooltip') invalidTooltip: NgbTooltip;
  fieldType: string;
  pattern: any;
  patternErrorMsg: string;
  fCtrl: FormControl;
  mobilePattern: {};
  venueSetting: any;

  constructor(private router: ActivatedRoute) {
    this.mobilePattern = environment.mobilePatterns;
   }

  ngOnInit() {
    this.pattern = '';
    if (this.field.bepoz_field_name == "FirstName") {
      this.pattern = '^[A-Za-z\ \'\-]+$';
      this.patternErrorMsg = `Please enter a valid First Name.`;
    }

    if (this.field.bepoz_field_name == "LastName") {
      this.pattern = '^[A-Za-z\ \'\-]+$';
      this.patternErrorMsg = `Please enter a valid Last Name.`;
    }

    if (this.field.bepoz_field_name == "Mobile") {
      this.fieldType = 'text';
      this.venueSetting = this.router.snapshot.data['venueSettings'];
     // this.pattern = '^0(4|5)[0-9]{8}$';
     let country_code = '';
     switch (this.venueSetting.country) {
      case 'New Zealand':
        country_code = 'NZ';
        break;
      case 'United Kingdom':
        country_code = 'UK';
        break;
      case 'United States':
        country_code = 'US';
        break;
      default:
        country_code = 'AU';
        break;
    }
     this.pattern = new RegExp(this.mobilePattern[country_code].pattern);
      this.patternErrorMsg = `Please enter a valid Mobile Number.`;
    }

    if (this.field.bepoz_field_name == "PCode") {
      this.fieldType = 'text';
      this.patternErrorMsg = `Please enter a valid postcode.`;
      this.venueSetting = this.router.snapshot.data['venueSettings'];
      switch (this.venueSetting.country) {
        case 'New Zealand':
          this.pattern = new RegExp(/^\d{4}$/);
          break;
        case 'United Kingdom':
          this.pattern = '^([A-Z]){1}([0-9][0-9]|[0-9]|[A-Z][0-9][A-Z]|[A-Z][0-9][0-9]|[A-Z][0-9]|[0-9][A-Z]){1}([ ])?([0-9][A-z][A-z]){1}$';
          break;
        case 'United States':
          this.pattern = '^([0-9]{5})(?:-([0-9]{4}))?$';
          break;
        default:
          this.pattern = new RegExp(/^\d{4}$/);
          break;
      }
    }

    if (this.field.bepoz_field_name == "PhoneHome") {
      this.fieldType = 'text';
      this.pattern = '^0(1|2|3|6|7|8|9)[0-9]{8}$';
      this.patternErrorMsg = `Please enter a valid Phone Number.`;
    }

    if (this.field.bepoz_field_name == "Email1st") {
      this.fieldType = 'email';
      this.pattern = '^[a-zA-Z0-9.!#$%&’*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$';
      this.patternErrorMsg = `Please enter a valid Email Address.`;
    }

    if (this.field.bepoz_field_name == "Street1") {
      this.field.field_name = 'Building/Unit NO.';
    }

    if (this.field.bepoz_field_name == "Street2") {
      this.field.field_name = 'Street';
    }

    if (this.field.field_type == "Text") {
      this.fieldType = 'text';
    }

    if (this.field.field_type == "Number") {
      this.fieldType = 'text';
      this.pattern = '^[0-9]+$';
      this.patternErrorMsg = `Please enter a valid Number.`;
    }

    if (this.field.required) {
      this.fCtrl = new FormControl('', [Validators.required, Validators.pattern(this.pattern)]);
    } else {
      this.fCtrl = new FormControl('', [Validators.pattern(this.pattern)]);
    }

    // console.log(this.fCtrl);

    // listening input state changes
    this.fCtrl.statusChanges.subscribe(status => {
      // console.log(status);
      if (status == 'INVALID' && (this.fCtrl.dirty || this.fCtrl.touched)) {
        this.invalidTooltip.open();
      }
      if (status == 'VALID') {
        this.invalidTooltip.close();
      }
    });

    // pass formcontrol to field obj
    this.field.formControl = this.fCtrl;
    this.field.invalidTooltip = this.invalidTooltip;
  }

  ngOnChanges(changes: SimpleChanges) {
  }

  // when focus:blur check input status
  onFocusOutCheck(event) {
    if (this.fCtrl.invalid) {
      this.invalidTooltip.open();
    }
  }

}
